/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * DriverDeletedDtoBase
 * auto generated base class for the model DriverDeletedDtoModel.
 */
export const DriverDeletedDtoModelBase = ModelBase
  .named('DriverDeletedDto')
  .props({
    __typename: types.optional(types.literal("DriverDeletedDto"), "DriverDeletedDto"),
    deleted: types.union(types.undefined, types.boolean),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class DriverDeletedDtoModelSelector extends QueryBuilder {
  get deleted() { return this.__attr(`deleted`) }
}
export function selectFromDriverDeletedDto() {
  return new DriverDeletedDtoModelSelector()
}

export const driverDeletedDtoModelPrimitives = selectFromDriverDeletedDto().deleted
